import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import store from '@/store'
import Rules from '@/composables/rules'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

//Control de rutas privadas
router.beforeEach((to, from, next) => {
    //Comprobamos si la ruta tiene definida la meta requiresAuth
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const token = store.state.auth.token

    if (!requiresAuth && token.length && to.path === '/login') {
        //Si el usuario está logueado e intenta volver al login, redirigimos a /
        return next('/home')
    } else if (requiresAuth && !token.length) {
        //Si el usuario no está logueado impedimos que acceda a /
        return next('/login')
    }

    if (token.length && requiresAuth) {
        const parseToken = JSON.parse(atob(token.split('.')[1]))
        const userData = JSON.parse(parseToken.UserData)
        if (to.path !== '/home' && userData.id_role !== 'admin') {
            if (to.meta.hasOwnProperty('authorize') &&
                (!to.meta.authorize.includes(userData.id_role) || !Rules(userData, to.name, to.params))) {
                    return next('/home')
            }
        }
    }
    return next()
})

export default router
